/**
 * Pure formatting for the sidebar's alert-bubble counts (Sidebar.tsx). Kept
 * standalone so the cap logic is testable without rendering the sidebar.
 */

// Full-size bubble in the expanded sidebar and mobile drawer: caps at 99+ so
// a large count can never stretch the row.
export function formatBadgeCount(count: number): string {
  return count > 99 ? '99+' : String(count);
}

// Mini bubble on a department icon in the 60px collapsed rail: a tighter cap
// (9+) so the two-character label still fits inside a small dot without
// overflowing the icon.
export function formatMiniBadgeCount(count: number): string {
  return count > 9 ? '9+' : String(count);
}
